var BOG_LINE_GAME_TYPES = {
    ONLY_CRASH: 'ONLY_CRASH',
    ONLY_MARKET: 'ONLY_MARKET',
    MARKET_AND_CRASH: 'MARKET_AND_CRASH',
};

export { BOG_LINE_GAME_TYPES };
